/* unplugin-vue-components disabled */import script from "./about.vue?vue&type=script&setup=true&lang=js"
export * from "./about.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__